import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import compo1 from "../images/compo1.jpeg";
import comp2 from "../images/comp2.jpeg";
import compo3 from "../images/compo3.jpeg";
import compo4 from "../images/compo4.jpeg";
import compo5 from "../images/compo5.jpeg";
import compo6 from "../images/compo6.jpeg";
import compo7 from "../images/compo7.jpeg";
import compo8 from "../images/compo8.jpeg";
import compo9 from "../images/compo9.jpeg";
import compo10 from "../images/compo10.jpeg";

const ledComponents = [
  { img: compo1, title: "Capacitor", purpose: "Primary light-producing components of the PCB.", placement: "Mounted on the PCB based on application (single-point or matrix layout)." },
  { img: comp2, title: "Inductance", purpose: "Limit current flow to ensure LEDs operate within safe limits.", placement: "Often placed near LEDs to control current." },
  { img: compo3, title: "Integrated Circuit", purpose: "Smooth power supply signals and stabilize voltage.", placement: "Typically placed in parallel with the power supply or near LEDs." },
  { img: compo4, title: "Inductors", purpose: "Used for current regulation and voltage conversion.", placement: "Commonly found in power supply circuits or complex LED drivers." },
  { img: compo10, title: "YK Connector", purpose: "Conductive paths that carry electrical signals.", placement: "Spread throughout the PCB to connect components." },
  { img: compo6, title: "LED Diodes", purpose: "Control power, brightness, dimming, and temperature regulation.", placement: "Installed near power management sections or LED drivers." },
  { img: compo7, title: "Solder Pads", purpose: "Attach LED PCB to power supplies or other circuits.", placement: "Varies; can be pin headers, solder pads, or external connectors." },
  { img: compo8, title: "Precision Solder Points", purpose: "Metal pads where components like LEDs, resistors, and capacitors are soldered.", placement: "Located at specific points for mounting components." },
];

const LEDPCB = () => {
  return (
    <Container className="led-pcb-section">
      <motion.h2 className="text-center" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        LED PCB Components
      </motion.h2>
      <Row className="justify-content-center">
        {ledComponents.map((item, index) => (
          <Col key={index} xs={12} sm={6} md={4} className="mb-3">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="led-card text-center">
                <motion.div whileHover={{ scale: 1.05 }} className="icon-wrapper">
                  <img src={item.img} alt={item.title} className="component-image" />
                </motion.div>
                <Card.Body>
                  <Card.Title>{item.title}</Card.Title>
                  <Card.Text><strong>Purpose:</strong> {item.purpose}</Card.Text>
                  <Card.Text><strong>Placement:</strong> {item.placement}</Card.Text>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default LEDPCB;
